const fakeWrapper = props => props.children;

export default fakeWrapper;



// WEBPACK FOOTER //
// ./src/App/hoc/fakeWrapper.jsx